/**
 * AUTO-GENERATED by scripts/generate-module-manifest.ts
 * DO NOT EDIT THIS FILE BY HAND.
 *
 * Run `pnpm gen:modules` after adding, removing, or renaming a
 * `modules/*` folder — the generator infers the SCREAMING_SNAKE key
 * from the kebab-case folder name.
 *
 * This file is checked into git so CI and production builds never
 * need to run the generator — it is purely a developer convenience.
 *
 * Imported via `packages/shared/src/module-ids.ts` which re-exports
 * it as `MODULES` / `ModuleId` for backward compatibility.
 */

/* eslint-disable */
// prettier-ignore-start

export const GENERATED_MODULES = {
  ACCOUNTING: 'accounting',
  AI: 'ai',
  CAR_RENTAL: 'car-rental',
  CHAT: 'chat',
  CONNECTORS: 'connectors',
  CORE: 'core',
  CRM: 'crm',
  DORMITORY: 'dormitory',
  FLEET: 'fleet',
  HR: 'hr',
  INVENTORY: 'inventory',
  MARKETING: 'marketing',
  PURCHASE: 'purchase',
  SALES: 'sales',
} as const

export type GeneratedModuleId = (typeof GENERATED_MODULES)[keyof typeof GENERATED_MODULES]

// prettier-ignore-end
